import React from 'react';
import { Select } from 'antd';
import { useGET } from '@API2';

const { Option } = Select;

const HJSelectBox = (props) => {
  const { data = [], loading, error } = useGET(props.url, props.key);

  if (error) return 'Liste alınamadı.';

  return (
    <Select
      loading={loading}
      allowClear
      showSearch
      {...props}
      placeholder={props.placeholder}
      filterOption={(input, option) => {
        const attr = option[props.name || 'name'];
        if (attr) {
          return attr.indexOf(input.toLocaleLowerCase('tr')) >= 0;
        }
      }}
    >
      {data.length > 0 &&
        data.map((item, index) => {
          if (!item[props.name || 'name']) {
            return null;
          }
          return (
            <Option
              key={index}
              value={item[props.selectedvalue || 'id']}
              name={item[props.name || 'name']?.toLocaleLowerCase('tr')}
            >
              {item[props.name || 'name']}
            </Option>
          );
        })}
    </Select>
  );
};

export default HJSelectBox;
